import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackage2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.16667 18.104V10.479L2.5 6.62484V13.3123C2.5 13.6179 2.57292 13.8957 2.71875 14.1457C2.86458 14.3957 3.06944 14.5971 3.33333 14.7498L9.16667 18.104ZM10.8333 18.104L16.6667 14.7498C16.9306 14.5971 17.1354 14.3957 17.2812 14.1457C17.4271 13.8957 17.5 13.6179 17.5 13.3123V6.62484L10.8333 10.479V18.104ZM14.1458 6.64567L16.6042 5.20817L10.8333 1.89567C10.5694 1.74289 10.2917 1.6665 10 1.6665C9.70833 1.6665 9.43056 1.74289 9.16667 1.89567L7.52083 2.83317L14.1458 6.64567ZM10 9.0415L12.4792 7.62484L5.875 3.7915L3.375 5.229L10 9.0415Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPackage2);
export default ForwardRef;
